import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function Loading({ isLoading, size, ...rest }) {
  return isLoading ? (
    <FontAwesomeIcon icon="spinner" spin={true} size={size || "lg"} {...rest} />
  ) : null;
}
